module.exports = __webpack_public_path__ + "img/eroeffnung.97810e98.jpg";